import { render, staticRenderFns } from "./MostViewedSubcategories.vue?vue&type=template&id=07cfed30&"
import script from "./MostViewedSubcategories.vue?vue&type=script&lang=js&"
export * from "./MostViewedSubcategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports